module.exports = __webpack_public_path__ + "img/kerry_icon_black.15c587f4.png";